import { DialogFooter } from '@fluentui/react';
import AppContext from 'App/AppContext';
import { IPDefaultButton, IPIconButton, IPModal, IPPrimaryButton, IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { IPTextField } from 'baseComponents/TextField/IPTextField';
import { cancelIcon, globalStackStylesHeight100PaddingMedium, globalStackTokensGapMedium } from 'globalStyles';
import { FormEvent, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'utils/string';

interface IOutOfScopeDialogProps {
  isActionPending: boolean;
  isOutOfScope?: boolean;
  reason?: string;
  isOpen: boolean;
  dismiss: () => void;
  setOutOfScope: (reason: string | undefined) => void;
}

const OutOfScopeDialog = (props: IOutOfScopeDialogProps) => {
  const { t } = useTranslation(['control']);
  const [reason, setReason] = useState<string | undefined>('');
  const appContext = useContext(AppContext);

  const getErrorMessage = (): string => {
    if (isEmpty(reason)) {
      return t('control:TabDetails.Fields.OutOfScope.ReasonDialog.Error');
    }

    return '';
  };

  useEffect(() => {
    setReason(props.reason);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IPModal isBlocking={false} isOpen={props.isOpen} onDismiss={props.dismiss}>
      <IPStack styles={globalStackStylesHeight100PaddingMedium} tokens={globalStackTokensGapMedium}>
        <IPStack horizontal horizontalAlign={'space-between'}>
          <IPText variant="xLarge">{t('control:TabDetails.Fields.OutOfScope.ReasonDialog.Title')}</IPText>
          <IPIconButton iconProps={cancelIcon} onClick={props.dismiss} />
        </IPStack>
        <IPText>{t('control:TabDetails.Fields.OutOfScope.ReasonDialog.SubText')}</IPText>
        <IPTextField
          autoFocus={!appContext.isMobileView}
          styles={{ root: { minWidth: 400 } }}
          value={reason ?? ''}
          multiline
          rows={10}
          maxLength={2048}
          onChange={(event: FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
            setReason(newValue);
          }}
          errorMessage={getErrorMessage()}
        />
        <DialogFooter>
          <IPPrimaryButton
            disabled={props.isActionPending || isEmpty(reason)}
            onClick={() => {
              props.dismiss();
              props.setOutOfScope(reason);
            }}
            text={t('control:TabDetails.Fields.OutOfScope.ReasonDialog.SetOutOfScope')}
          />
          <IPDefaultButton
            disabled={props.isActionPending}
            onClick={() => {
              props.dismiss();
            }}
            text={t('control:TabDetails.Fields.OutOfScope.ReasonDialog.Cancel')}
          ></IPDefaultButton>
        </DialogFooter>
      </IPStack>
    </IPModal>
  );
};

export default OutOfScopeDialog;
